import { Button, H5, H6, SizableText, Stack, XStack } from "tamagui";
import {
  ArrowLeftRegular,
  ArrowRightRegular,
  CaretDoubleLeftRegular,
  CaretDoubleRightRegular,
  CaretLeftRegular,
  CaretRightRegular
} from "@tamagui-extras/core";
import { useMonth } from "@datepicker-react/hooks";
import { LmDay } from "./LmDay";
import { useDatepickerContext } from "./DatepickerProvider";
import { jsx, jsxs } from "react/jsx-runtime";
function LmMonth({
  onPrevious,
  onNext,
  monthsCount,
  isFirst,
  isLast,
  ...props
}) {
  const { days, weekdayLabels, monthLabel } = useMonth({
    ...props,
    monthLabelFormat(date) {
      return new Intl.DateTimeFormat(void 0, { month: "long" }).format(date);
    }
  }), {
    goToPreviousYear,
    goToPreviousMonths,
    goToPreviousMonthsByOneMonth,
    goToNextMonthsByOneMonth,
    goToNextMonths,
    goToNextYear
  } = useDatepickerContext(), { year } = props;
  return /* @__PURE__ */ jsxs(Stack, { width: 250, children: [
    /* @__PURE__ */ jsxs(XStack, { space: "$2", justifyContent: "center", alignItems: "center", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          size: "$2",
          chromeless: !0,
          focusable: !1,
          circular: !0,
          onPress: () => goToPreviousYear(10),
          icon: /* @__PURE__ */ jsx(CaretDoubleLeftRegular, {})
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          size: "$2",
          chromeless: !0,
          circular: !0,
          focusable: !1,
          onPress: () => goToPreviousYear(1),
          icon: /* @__PURE__ */ jsx(CaretLeftRegular, {})
        }
      ),
      /* @__PURE__ */ jsx(H6, { children: year }),
      /* @__PURE__ */ jsx(
        Button,
        {
          size: "$2",
          chromeless: !0,
          focusable: !1,
          onPress: () => goToNextYear(1),
          icon: /* @__PURE__ */ jsx(CaretRightRegular, {}),
          circular: !0
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          size: "$2",
          chromeless: !0,
          circular: !0,
          focusable: !1,
          onPress: () => goToNextYear(10),
          icon: /* @__PURE__ */ jsx(CaretDoubleRightRegular, {})
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(XStack, { justifyContent: "space-between", alignItems: "center", height: 40, children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          focusable: !1,
          opacity: isFirst ? void 0 : 0,
          disabled: !isFirst,
          onPress: monthsCount > 1 ? goToPreviousMonths : goToPreviousMonthsByOneMonth,
          icon: /* @__PURE__ */ jsx(ArrowLeftRegular, {}),
          circular: !0,
          chromeless: !0
        }
      ),
      /* @__PURE__ */ jsx(H5, { children: monthLabel }),
      /* @__PURE__ */ jsx(
        Button,
        {
          focusable: !1,
          opacity: isLast ? void 0 : 0,
          disabled: !isLast,
          onPress: monthsCount > 1 ? goToNextMonths : goToNextMonthsByOneMonth,
          icon: /* @__PURE__ */ jsx(ArrowRightRegular, {}),
          circular: !0,
          chromeless: !0
        }
      )
    ] }),
    /* @__PURE__ */ jsx(XStack, { flex: 7, width: 250, children: weekdayLabels.map((dayLabel) => /* @__PURE__ */ jsx(
      SizableText,
      {
        width: `${100 / 7}%`,
        textAlign: "center",
        paddingVertical: "$2",
        children: dayLabel
      },
      dayLabel
    )) }),
    /* @__PURE__ */ jsx(XStack, { display: "flex", flexWrap: "wrap", width: 250, children: days.map((day, index) => typeof day == "object" ? /* @__PURE__ */ jsx(LmDay, { dayLabel: day.dayLabel, date: day.date }, day.date.toString()) : /* @__PURE__ */ jsx(Stack, { width: `${100 / 7}%` }, index)) }),
    /* @__PURE__ */ jsx(XStack, { display: "flex" })
  ] });
}
export {
  LmMonth
};
//# sourceMappingURL=LmMonth.js.map
